import JSONAPISerializer from '@ember-data/serializer/json-api';

/**
 * Base serializer for all ember-data requests in the app
 */
export default class RiseApiSerializer extends JSONAPISerializer {
  // Delegate findRecord through queryRecord to avoid 404->200 security requirement
  normalizeQueryRecordResponse(store, primaryModelClass, payload, id, requestType) {
    const documentHash = this.normalizeArrayResponse(...arguments);
    documentHash.data = documentHash.data[0];
    return documentHash;
  }
}
